import { hotPosts } from '@/mocks/blackliao';

export default function HotRank() {
  return (
    <section id="hot" className="w-full bg-background-100/60">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-5 md:mb-7">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-semibold text-primary-700 whitespace-nowrap">
              <i className="ri-fire-fill"></i>新黑料网热帖排行
            </span>
            <h2 className="mt-2.5 text-xl md:text-2xl font-black text-foreground-950">今日最热讨论，按热度实时排序</h2>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-600">综合浏览量、社区评论、围观互动与转发收藏动态更新。</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-time-line text-primary-500"></i>每 5 分钟刷新
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
          <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 flex items-center gap-1.5">
                <i className="ri-flag-2-fill text-primary-500"></i>全站热帖
              </h3>
              <span className="text-[11px] text-foreground-500 whitespace-nowrap">已按热度倒序</span>
            </div>
            <ul className="space-y-2">
              {hotPosts.map((p) => (
                <li key={p.id}>
                  <a
                    href="#forum"
                    className="group flex items-start gap-3 rounded-md px-2 py-2.5 hover:bg-background-100 transition-colors"
                  >
                    <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-black ${p.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-foreground-500'}`}>
                      {p.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-[13px] md:text-sm font-medium leading-relaxed text-foreground-900 group-hover:text-primary-700">{p.title}</p>
                      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">
                        {p.tags.map((t) => (
                          <span key={t} className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800 whitespace-nowrap">{t}</span>
                        ))}
                        <span className="flex items-center gap-1 text-[11px] text-primary-600 whitespace-nowrap"><i className="ri-fire-fill text-primary-500"></i>{p.heat}</span>
                        <span className="text-[11px] text-foreground-500 whitespace-nowrap">评论 {p.replies.toLocaleString()}</span>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-foreground-950 p-4 md:p-6 text-background-50 flex flex-col relative overflow-hidden">
            <span className="absolute -right-6 -top-6 h-32 w-32 rounded-full bg-primary-500/20"></span>
            <span className="absolute right-8 bottom-6 h-24 w-24 rounded-full bg-accent-500/20"></span>
            <div className="relative">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-semibold text-foreground-950 whitespace-nowrap">
                <i className="ri-quill-pen-fill"></i>新黑料网讨论 · 投稿
              </span>
              <h3 className="mt-3 text-lg md:text-xl font-black leading-snug">你也有瓜？来新黑料网论坛发第一手</h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-background-100/85">
                无论圈内八卦、职场爆料还是素人投稿，选对分区一键发布，等待全网新黑料网评论与围观补充。
              </p>
              <ul className="mt-4 space-y-2.5">
                {['选择对应分区并填写标题与实锤', '系统自动为你挂上热帖标签参与排行', '真实投稿可进入新黑料网热帖与全网围观'].map((t, i) => (
                  <li key={t} className="flex items-start gap-2 text-xs md:text-sm text-background-100/90">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background-50/15 text-accent-300 text-[11px] font-bold">{i + 1}</span>
                    {t}
                  </li>
                ))}
              </ul>
              <button className="mt-5 inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 h-9 text-sm font-semibold text-background-50 hover:bg-primary-400 transition-colors cursor-pointer">
                <i className="ri-quill-pen-line"></i>立即发布投稿
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}